/**
* WYSIWYG - jQuery plugin 0.5
*
* Copyright (c) 2008-2009 Juan M Martinez
* http://plugins.jquery.com/project/jWYSIWYG
*
* Dual licensed under the MIT and GPL licenses:
*   http://www.opensource.org/licenses/mit-license.php
*   http://www.gnu.org/licenses/gpl.html
*
* 04/03/2009 - mzalewski: 
*   Modified to add spell checking 
*   capability to WYSIWYG editor and removed the formatting
*   functions
*
* $Id: $
*/

(function($) {

    /// <summary>
    /// Adds a 'document()' function to jQuery which returns either the default document
    /// or the content's document if the current element is an iFrame
    /// </summary>
    $.fn.document = function() {
        var element = this[0];
        if (element.nodeName.toLowerCase() == 'iframe')
            return element.contentWindow.document;
        else
            return $(this);

    };
    /// <summary>
    /// Extends jQuery with a spellchecker() function.
    /// This is used to add spell-checking functionality to input/textarea elements
    /// </summary>
    /// <example>
    /// The following example adds spellchecking to all textarea elements that have a className of spellexample
    ///   $('textarea.spellexample').spellchecker();
    /// Options can be specified to override the default:
    ///   $('textarea.spellexample').spellchecker({ language: 'en' });
    /// </example>
    $.fn.spellchecker = function(options) {
        // Set default options
        var options = $.extend({
            html: '<' + '?xml version="1.0" encoding="UTF-8"?' + '><!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd"><html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en"><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><style>body { }.error { background:url(content/images/spellerror.gif) repeat-x bottom left;}</style></head><body spellcheck="false">INITIAL_CONTENT</body></html>',
            css: { margin: '0px' },

            debug: false,
            language: 'en',
            autoSave: true,
            rmUnwantedBr: true,
            brIE: true
        }, options);
        // Iterate through all elements returned by the specified jQuery selector (ie: 'textarea.spellexample')
        // and invoke the SpellCheckedTextbox function
        return this.each(function() {
            SpellCheckedTextbox(this, options);
        });
    };
    /// <summary>
    /// Creates a new instance of SpellCheckedTextBox
    /// </summary>
    function SpellCheckedTextbox(element, options) {
        // execute init function and return constructed object
        return this instanceof SpellCheckedTextbox
            ? this.init(element, options)
            : new SpellCheckedTextbox(element, options);
    }
    $.extend(SpellCheckedTextbox.prototype,
    {

        options: {},
        element: null,
        editor: null,

        /// <summary>
        /// Initialise the SpellCheckedTextBox
        /// </summary>
        init: function(element, options) {

            // Create reference to self to be used in anonymous functions
            var self = this;
            // Set default options
            this.options = options || {};
            // Assign original element to this.original
            this.original = element;

            // Associate this SpellCheckedTextBox instance with element
            $.data(element, 'spellchecked', this);
            // Get Width/Height + 6px for padding
            var newX = $(element).css('width');
            var newY = $(element).css('height');

            // If width/height was not specified, work it out using the rows/cols attributes
            if (newX == 0 && element.cols)
                newX = (element.cols * 8) + 21;

            if (newY == 0 && element.rows)
                newY = (element.rows * 16) + 16;

            // Create iframe and set id/style attributes
            var editor = this.editor = $('<iframe></iframe>').attr('id', $(element).attr('id') + 'IFrame').css({ display: "inline", backgroundColor: "white" });

            var elementType = element.nodeName.toLowerCase();

            if (elementType == 'textarea') {                    // Apply TEXTAREA-specific properties


                this.options.css = $.extend({                   // Generated BODY css
                    overflowY: 'scroll',                        // - Show vertical scrollbar
                    overflowX: 'auto',                          // - Show horizontal scrollbar when needed
                    padding: '2px',                             // - Set body padding to 2px
                    wordWrap: 'break-word',                     // - Force text to wrap, breaking words if required (IE only)
                    fontFamily: $(element).css('font-family'),                  // - Font family is Courier New
                    fontSize: $(element).css('font-size'),                           // - Set font size to 9.5pt
                    cursor: 'text'
                }, this.options.css);


                this.editor.css({                               // IFRAME css

                    height: '100%',           // - Set height to calculated newHeight
                    width: '100%',             // - Set width to calculated newWidth
                    border: '0px none'
                });

            } else if (elementType == 'input') {                // Apply INPUT-specific properties

                this.options.css = $.extend({                   // Generated BODY css
                    padding: '2px',                             // - Set padding to 2 pixels
                    fontFamily: $(element).css('font-family'),                        // - Use 'Arial' font
                    fontSize: $(element).css('font-size'),                          // - Set font size to 9.5pt
                    wordWrap: 'normal',                         // - Normal word-wrap - don't break words (IE only)
                    whiteSpace: 'nowrap',                        // - Wrapping disabled for whitespace characters
                    cursor: 'text'
                }, this.options.css);

                this.editor.attr("scrolling", "no");            // Disable page scrolling (generated page)

                this.editor.css({                               // IFRAME css

                    height: $(element).css('height'),                             // Set height to 22px to match standard input height
                    width: '100%',             // Set width to calculated newWidth
                    border: '0px none'
                });
            }


            $(element).change(function() {

                if ($(element).val() == self.getTextContent())
                    return;


                self.setContent($(element).val());
            });
            this.element = $('<div style="display:inline"></div>').addClass('spellchecked')
                .append(editor)
                .attr('style', $(element).attr('style'));

            // Hide the original element (We can't remove the element because it's needed for form POST)
            $(element).hide().before(this.element);

            //   if ($(element).attr('readonly') && ($(element).attr('readonly') == "readonly" || $(element).attr('readonly') == true)) {
            ///       $(this.element).attr('readonly', 'readonly');
            //  }
            //    $(element).show();
            //    this.element.hide();
            //  }
            //$(element).data('spellcheck', this.element);
            // Set initialContent of iframe 
            this.initialContent = $(element).val();

            // Initialise the IFrame
            this.initFrame();

            // Clear iframe if content length = 0
            if (this.initialContent.length == 0)
                this.setContent('');

            // If autoSave (default==true), then set to update original element value on submit
            if (this.options.autoSave)
                $('form').submit(function() { self.saveContent(); });

            // If form is reset, restore original content
            $('form').bind('reset', function() {
                self.setContent(self.initialContent);
                self.saveContent();
            });
        },

        /// <summary>
        /// Initialises the new IFRAME
        /// </summary>
        initFrame: function() {

            // create reference to self to be used in anonymous functions
            var self = this;

            // Assigns the IFRAME's document to editorDoc
            this.editorDoc = $(this.editor).document();
            this.editorDoc_designMode = false;

            try {
                this.editorDoc.designMode = 'on';
                this.editorDoc_designMode = true;
            } catch (e) {
                // Will fail on Gecko if the editor is placed in an hidden container element
                // The design mode will be set ones the editor is focused

                $(this.editorDoc).focus(function() {

                    self.designMode();
                });
            }

            // Open IFRAME document for editing
            this.editorDoc.open();

            // Write HTML to document
            this.editorDoc.write(
                this.options.html
                    .replace(/INITIAL_CONTENT/, this.initialContent)
            );
            // Set contentEditable to 'true' - this tells the browser that the user can edit the content
            this.editorDoc.contentEditable = 'true';
            // Close document
            this.editorDoc.close();


            if ($(this.original).attr('disabled') && ($(this.original).attr('disabled') == 'disabled' || $(this.original).attr('disabled') == true)) {
                // Hide this and show original
                $(this.element).hide();
                $(this.original).show();
            }

            // when original is enabled
            $(this.original).bind('enabled', function() {

                $(self.element).show();
                $(self.original).hide();
            });
            // when original is disabled
            $(this.original).bind('disabled', function() {
                $(self.element).hide();
                $(self.original).show();
            });

            // If using IE
            if ($.browser.msie) {
                // Clear the IFRAME border
                setTimeout(function() { $(self.editorDoc.body).css('border', 'none'); }, 0);
            }

            // When user clicks anywhere in the document
            $(this.editorDoc).click(function(event) {
                // Hide all errorList divs (These are divs containing suggestions)
                $('div.errorList').hide();
            });

            // If the original element receives focus - pass on to the IFRAME instead
            $(this.original).focus(function() {
                $(self.editorDoc.body).focus();
            });

            // If autoSave is enabled

            // Update original element value whenever user presses a key or mouse button
            $(this.editorDoc).keydown(function() { self.saveContent(); $(self.element).trigger('keydown'); })
                                 .mousedown(function() { self.saveContent(); $(self.element).trigger('mousedown'); })
                                 .keyup(function() { self.saveContent(); $(self.element).trigger('keyup'); });


            // If CSS is defined in options
            if (this.options.css) {
                // Apply style to editor's document-body 
                setTimeout(function() {
                    $(self.editorDoc).find('body').css(self.options.css);
                }, 0);
            }

            // On Key Up (key released), perform Firefox-hack:
            // Firefox doesn't automatically scroll if overflow is set to hidden
            // We need the user to be able to see what he/she is typing, so try
            // to scroll automatically
            $(this.editorDoc).keyup(function(event) {
                if (!$.browser.msie) {
                    // Get caret position within string
                    var offset = self.editor[0].contentWindow.getSelection().getRangeAt(0).startOffset;
                    // Get text before caret position
                    var val = $(self.editor[0].contentWindow.document).find('body').text().substring(0, offset);
                    // Copy text to a new span element - Style is copied from the editor to ensure that the text is the same size
                    var span = $("<span></span>").html(val).attr("style", $(self.editor[0].contentWindow.document).find('body').attr("style")).css({ visibility: 'hidden' });
                    // Add span element to body (this is required otherwise width() returns 0)
                    span.appendTo($(document.body));
                    // Get the width of the new span element
                    var width = span.width();
                    // Remove the span element
                    span.remove();
                    // Scroll to calculated caret position
                    self.editor[0].contentWindow.scrollTo(width - 30, 5);
                }
            });

            // Every time the user presses a key while editor document has focus
            $(this.editorDoc).keydown(function(event) {

                // only perform spelling check if user has not pressed a key within the last 600ms
                if (this.spellingTimer)
                    window.clearTimeout(this.spellingTimer);
                this.spellingTimer = window.setTimeout(function() { self.checkSpelling() }, 600);

                // If user presses enter - Apply IE <br /> hack
                if ($.browser.msie && self.options.brIE && event.keyCode == 13) {
                    var rng = self.getRange();
                    rng.pasteHTML('<br />');
                    rng.collapse(false);
                    rng.select();
                    return false;
                }
            });
        },
        /// <summary>
        /// Checks the spelling using ASP.NET handler
        /// </summary>
        checkSpelling: function() {

            // No need to perform spelling check if content hasn't changed
            if (this.oldTextContent && this.oldTextContent == this.getTextContent())
                return;
            this.oldTextContent = this.getTextContent();

            // Send asynchronous request to spellcheck handler and execute parseResults when done
            $.ajax({
                url: this.options.url,
                type: 'GET',
                data: $.extend({ text: this.getTextContent() }, this.options),
                dataType: 'xml',
                timeout: 1000,
                success: this.parseResults,
                caller: this
            });

        },
        /// <summary>
        /// Parses results returned by handler
        /// </summary>
        parseResults: function(results) {
            // reference to self for anonymous functions
            var self = this;

            var parsedResults = [];
            var txt = this.caller.getTextContent();
            // Iterate through 'c' elements in results (XML)
            $(results).find('c').each(function() {

                // Get the position/length of the incorrect word
                var $this = $(this),
				offset = $this.attr('o'),
				length = $this.attr('l');

                // Add to parsedResults array with suggestions
                parsedResults.push({
                    word: txt.substr(offset, length),
                    suggestions: $this.text().split(/\s/)
                });
            });
            // Display the results
            this.caller.displayResults(this.caller, parsedResults);
        },
        /// <summary>
        /// Displays the spellcheck results
        /// </summary>
        displayResults: function(editor, parsedResults) {

            var offsetRange = this.editor.get(0).contentWindow.getSelection().getRangeAt(0);
            var offset = offsetRange.startOffset;
            if (offsetRange.startContainer.parentNode != this.editor.get(0).contentWindow.document.body) { // Is an ERROR span
                // find index
                var index = 0;
                var currentEl = offsetRange.startContainer.parentNode;
                while (currentEl.previousSibling != null) {
                    currentEl = currentEl.previousSibling;
                    index = index + currentEl.textContent.length;
                }
                offset = offset + index;
            } else if (offsetRange.startContainer.previousSibling) { // Is a text range with preceding ERROR spans
                var index = 0;
                var currentEl = offsetRange.startContainer;
                while (currentEl.previousSibling != null) {
                    currentEl = currentEl.previousSibling;
                    index = index + currentEl.textContent.length;
                }
                offset = offset + index;
            }
            // Remove all existing errors from editor
            editor.clearErrors();

            // IF no errors, then return
            if (!parsedResults.length) return;

            // Foreach result in parsedResults
            $(parsedResults).each(function(index, value) {
                // call setError function
                editor.setError(value.word, value.suggestions);
            });
            // Set offset again
            // We have to loop through children
            // Try to find position of offset.startOffset (it may be inside an element now)
            var totalLength = 0;
            var innerOffset = 0;
            var nodes = this.editor.get(0).contentWindow.document.body.childNodes;
            var foundNode = false;
            for (var i = 0; i < nodes.length; i++) {
                var txtContent = nodes[i].textContent;

                if (totalLength + txtContent.length >= offset && foundNode == false) {
                    // We have found the element!
                    foundNode = nodes[i];
                    innerOffset = offset - totalLength;
                }
                totalLength = totalLength + txtContent.length;
            }

            if (foundNode != false) {
                var range = this.editor.get(0).contentWindow.getSelection().getRangeAt(0);
                if (foundNode.firstChild) {
                    foundNode = foundNode.firstChild;

                }
                range.setStart(foundNode, innerOffset);
                range.setEnd(foundNode, innerOffset);
            }
        },
        /// <summary>
        /// Returns HTML content of editor
        /// </summary>
        getContent: function() {
            return $($(this.editor).document()).find('body').html();
        },
        /// <summary>
        /// Returns content of editor as text
        /// </summary>
        getTextContent: function() {
            return $($(this.editor).document()).find('body').text();
        },
        /// <summary>
        /// Sets the HTML content of the editor
        /// </summary>
        setContent: function(newContent) {
            // Set content
            // Get caret position
            //debugger;

            //alert(offset);
            $($(this.editor).document()).find('body').html(newContent);

            // Find all error spans and add showMenu jQuery extension
            $($(this.editor).document()).find('.error').showMenu({
                opacity: 0.95,
                query: function(ev) { $('div.errorList').hide(); var text = $(ev.target).text(); return $('div.errorList.' + text.replace(/[^A-Za-z0-9]/g, '')); }
            });
        },

        /// <summary>
        /// Clears all error spans and removes all errorList elements
        /// </summary>
        clearErrors: function() {
            // Finds all spans marked with class=error and replaces them with the element's value
            $(this.editor.document()).find('body').find('span.error').each(function(ind, obj) { $(obj).before($(obj).text()).remove(); });
            // Removes all errorList DIVs
            $(document.body).find('div.errorList').remove();
        },
        /// <summary>
        /// Update content with the suggested word selected by the user
        /// </summary>
        replaceWord: function(errorWord, replaceWith) {
            // Get HTML
            var html = $($(this.editor).document()).find('body').html();
            // Replace the misspelled word with replaceWith
            $($(this.editor).document()).find('body').html(html.replace(new RegExp("\\b(" + errorWord + ")\\b", "g"), replaceWith));
            // Run spelling check again to verify that the spelling is now correct
            this.checkSpelling();
        },
        /// <summary>
        /// Creates an unorderedlist containing the suggested words, and marks the word as incorrect
        /// </summary>
        setError: function(errorWord, suggestions) {
            // Get reference to self to be used in anonymous functions
            var self = this;

            // Find existing errorList (maybe the word is misspelled twice in the same textbox?)
            errorlist = $('div.errorList.' + errorWord.replace(/([^A-Za-z0-9]*)/g, ""));

            // If no existing errorList is found
            if (errorlist.length == 0) {
                // Create a new one
                errorCM = $("<div class='errorList " + errorWord.replace(/([^A-Za-z0-9]*)/g, "") + "'><ul></ul></div>");
                // Add the suggestions to it
                // If suggestions have been returned
                if ($(suggestions).length > 0 && ($(suggestions)[0].trim() != '')) {

                    $(suggestions).each(function(i, val) {
                        var li = $("<li><a>" + val + "</a></li>");
                        // On click, execute the replaceWord function
                        li.find('a').click(function(obj) { self.replaceWord(errorWord, val); });
                        errorCM.find('ul').append(li);
                    });
                } else { // If suggestions have not been returned
                    // Display static text
                    var li = $("<li class='disabled'>No suggestions found</li>");
                    errorCM.find('ul').append(li);
                }
                // Add errorList to page
                errorCM.appendTo($(this.editor).parents()[0]);
            }
            // Get current content
            var html = $($(this.editor).document()).find('body').html();
            // Replace all misspelled words with underlined spans
            this.setContent(html.replace(new RegExp("\\b(" + errorWord + ")\\b", "g"), "<span class='error'>$1</span>"));
        },

        /// <summary>
        /// Copies the edited value back to the original element in preparation for form post (or other activity)
        /// </summary>
        saveContent: function() {
            // Make sure the original element exists
            if (this.original) {

                var content = this.getContent();
                // Copy text to original element, removing all HTML tags
                content = content.replace(/<BR>/g, '\n').replace(/<(.*?)>/g, '');
                if ($(this.original).val() != content) {
                    $(this.original).val(content);
                    $(this.original).trigger('change');
                }
            }
        }

    });
})(jQuery);